/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SubscriptionOfferDescription } from './SubscriptionOfferDescription';
import {
    SubscriptionOfferDescriptionFromJSON,
    SubscriptionOfferDescriptionFromJSONTyped,
    SubscriptionOfferDescriptionToJSON,
    SubscriptionOfferDescriptionToJSONTyped,
} from './SubscriptionOfferDescription';

/**
 * 
 * @export
 * @interface GetOfferDescriptionResponse
 */
export interface GetOfferDescriptionResponse {
    /**
     * 
     * @type {Array<SubscriptionOfferDescription>}
     * @memberof GetOfferDescriptionResponse
     */
    offers: Array<SubscriptionOfferDescription>;
}

/**
 * Check if a given object implements the GetOfferDescriptionResponse interface.
 */
export function instanceOfGetOfferDescriptionResponse(value: object): value is GetOfferDescriptionResponse {
    if (!('offers' in value) || value['offers'] === undefined) return false;
    return true;
}

export function GetOfferDescriptionResponseFromJSON(json: any): GetOfferDescriptionResponse {
    return GetOfferDescriptionResponseFromJSONTyped(json, false);
}

export function GetOfferDescriptionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetOfferDescriptionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'offers': ((json['offers'] as Array<any>).map(SubscriptionOfferDescriptionFromJSON)),
    };
}

export function GetOfferDescriptionResponseToJSON(json: any): GetOfferDescriptionResponse {
    return GetOfferDescriptionResponseToJSONTyped(json, false);
}

export function GetOfferDescriptionResponseToJSONTyped(value?: GetOfferDescriptionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'offers': ((value['offers'] as Array<any>).map(SubscriptionOfferDescriptionToJSON)),
    };
}

